/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_EvidenceInputs */

const en_directory_detail_section_evidence = /** @type {(inputs: Directory_Detail_Section_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence`)
};

const zh_directory_detail_section_evidence = /** @type {(inputs: Directory_Detail_Section_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`证据`)
};

/**
* | output |
* | --- |
* | "Evidence" |
*
* @param {Directory_Detail_Section_EvidenceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_evidence = /** @type {((inputs?: Directory_Detail_Section_EvidenceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_EvidenceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_evidence(inputs)
	return zh_directory_detail_section_evidence(inputs)
});
export { directory_detail_section_evidence as "directory.detail.section.evidence" }